var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg3White = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "77px",
    viewBox: "0 0 108 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.9,40.6 C107.9,36.1 105,32.4 100.6,32.4 C98.4,32.4 95.7,34.8 94.3,36.3 C92.9,34.8 90.4,32.4 88.2,32.4 C83.8,32.4 80.7,36.1 80.7,40.6 C80.7,42.9 81.6,44.9 83,46.4 L94.3,57.7 L105.6,46.4 C107,44.9 107.9,42.9 107.9,40.6 L107.9,40.6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9,76.1 C58.9,76 58.2,75.4 58.1,74.6 L52.4,41.2 L43.7,57.3 C43.3,58 42.5,58.4 41.7,58.2 C40.9,58.1 40.3,57.4 40.2,56.6 L36.5,30.8 L29.8,45.9 C29.5,46.6 28.8,47 28.1,47 L1.9,47 C0.9,47 5.68434189e-14,46.2 5.68434189e-14,45.1 C5.68434189e-14,44.1 0.8,43.2 1.9,43.2 L26.9,43.2 L35.8,23.3 C36.1,22.5 36.9,22.1 37.7,22.2 C38.5,22.3 39.2,23 39.3,23.8 L43.1,50.4 L51.7,34.5 C52.1,33.8 52.8,33.4 53.6,33.6 C54.4,33.7 55,34.3 55.1,35.1 L60.4,66 L79.7,1.8 C79.9,1.1 80.6,0.5 81.3,0.5 C82.1,0.4 82.8,0.9 83.1,1.5 L93.3,22.6 C93.7,23.5 93.4,24.6 92.4,25.1 C91.5,25.5 90.4,25.2 89.9,24.2 L81.8,7.4 L61.6,74.6 C61.4,75.6 60.7,76.1 59.9,76.1 L59.9,76.1 Z",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg3White);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/3_white.f906b4813b52cf1bfb987cca9df7b986.svg";